module.exports = __webpack_public_path__ + "img/symbol_0.864600f7.png";